export default __webpack_public_path__ + "static/media/featured_area_hamilton.cc9e48c1.webp";